import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Button, Link, TextField, Typography } from '@mui/material';

import './RememberPasswordForm.scss';

function RememberPasswordForm({ onSubmit, emailHasBeenSent }) {
  const navigate = useNavigate();

  function validate(values) {
    const errors = {};
  
    if (!values.email) {
      errors.email = 'Email inválido';
    }
  
    return errors;
  }

  return (
    <Formik
      initialValues={{ email: '' }}
      validate={validate}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form className="form">
          <Typography variant="h5" component="h1">
            Recuperar Senha
          </Typography>
          <Field
            as={TextField}
            className="field"
            type="email"
            name="email"
            label="Email"
            variant="outlined"
            fullWidth
          />
          <ErrorMessage name="email" component="div" />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="button"
            disabled={isSubmitting}
            fullWidth
          >
            {isSubmitting ? 'Enviando email ...' : 'Recuperar senha'}
          </Button>
          <Typography variant="p" component="p" className="instructions">
            Insira o email utilizado no cadastro e clique em 'Recuperar Senha'
          </Typography>
          {
            emailHasBeenSent && (
              <Link
                className="has-sent-email"
                onClick={() => navigate('../recover-password')}
              >
                Conseguiu enviar o email de recuperação?<br/>Ótimo! Agora clique neste link.
              </Link>
            )
          }
        </Form>
      )}
    </Formik>
  );
}

export default RememberPasswordForm;